<img _ngcontent-pge-c105="" src="../../assets/images/myvista-logo-white.png" alt="logo" class="hoverLogo" *ngIf="this.isEmbed === false">
<div class="iwg-form-dialog"  [ngClass]="{'iwg-dialog-half-size': selectedStepIndex == 4}">
    <div class="md-toolbar-tools d-flex md-theme m-0 p-3">
        <h2 class="m-0 toolbartitle">
            Get a Quote
        </h2>
        <span class="flex"></span>
        <span *ngIf="selectedStepIndex <= 3">Step {{selectedStepIndex + 1}} of {{maxSteps-1}}</span>
        <span *ngIf="selectedStepIndex > 3">Review & Submit</span>
    </div>
    <mat-progress-bar *ngIf="isLoading" mode="indeterminate"  color="accent" style="position: absolute;z-index: 9999;"></mat-progress-bar>
    <mat-dialog-content style="overflow: hidden;padding:0px;display: block;width: 100%;">
        <div class="vista-popup-height">
            <div class="d-flex layout-row " style="height: 100%;">
                <div style="overflow: hidden;" ng-style="getTabWidth() && {'width':'50%'} || {'width': '100%'}"  fxFlex.lt-md="100"class="d-flex layout-column flex md-padding w-100 head-mat">
                <div style="height:100%;overflow-y: auto;box-sizing: border-box;padding: 20px 30px 0;">
                    <mat-tab-group [(selectedIndex)]="selectedStepIndex" class="header-less-tabs">
                        <mat-tab label="Step 1">
                            <h3>Service and Location</h3>
                            <form name="quoteStep1" #quoteStep1="ngForm">
                                <div class="md-input-container">
                                    <mat-form-field class="mat-form-withtooltip">
                                        <mat-label [ngClass]="{'asterix--after': (TransferEORAssingmnetId > 0)}">Service</mat-label>
                                        <mat-select [(ngModel)]="step1.service_type_id" name="step1.service_type_id"
                                            #Sservice_type_id="ngModel" 
                                            (selectionChange)="OnChangeServiceType()" [disabled] = "TransferEORAssingmnetId > 0" required>
                                            <mat-option [value]="1" *ngIf="step1.include_EOR">
                                                Employer of Record
                                            </mat-option>
                                            <mat-option [value]="3" *ngIf="step1.include_Compliance">
                                                Compliance
                                            </mat-option>
                                            <mat-option [value]="2" *ngIf="step1.include_AOR">
                                                Agent of Record
                                            </mat-option>
                                        </mat-select>
                                        <mat-error *ngIf="!Sservice_type_id.valid && Sservice_type_id.touched">Required</mat-error>
                                    </mat-form-field>
                                    <mat-icon [matTooltip]="safe()"
                                    matTooltipPosition="above" class="ng-scope md-iwgNavbar-theme material-icons">
                                        help
                                    </mat-icon>
                                </div>
                                <div class="md-input-container">
                                    <mat-form-field class="mat-form-withtooltip">
                                        <mat-label>Quote Title</mat-label>
                                        <input matInput name="title" [(ngModel)]="step1.title" #Ctitle="ngModel"
                                            name="title" maxlength="200" required>
                                            <mat-error *ngIf="!Ctitle.valid && Ctitle.touched">Required</mat-error>
                                    </mat-form-field>
                                    <mat-icon matTooltip="Provide a title with enough context to help you track it."
                                        matTooltipPosition="above" class="ng-scope md-iwgNavbar-theme material-icons">
                                        help</mat-icon>
                                  
                                </div>
                                <div class="end-client-style" fxFlex="90">
                                    <app-end-client-select fxFlex="100" name="endclients" [(ngModel)]="step1.selectedEndClient"
                                    [preselectedItemId]="step1.selectedEndClient?step1.selectedEndClient.ID:null"
                                    [refresh-on-preselect]="true" *ngIf="allowEndClients"></app-end-client-select>
                                </div>
                                <div class="end-client-style" fxFlex="90">
                                <app-add-end-clients (added)="step1.selectedEndClient = $event"
                                [new-item-id]="step1.selectedEndClient?step1.selectedEndClient.ID:null"
                                *ngIf="allowEndClients"
                                ></app-add-end-clients>
                                </div>
                                <div class="md-input-container-top">
                                <app-team-select *ngIf="allowTeams" name="stepoTeamSel" [(ngModel)]="step1.selectedTeam" 
                                    [preselected-item-id]="step1.selectedTeam?step1.selectedTeam.ID:null"
                                    [filter-item-id-NOT]="Filter_ClientID"></app-team-select></div>
                                <!-- (ngModelChange)='getCountryRegionCode(step1.selectedCountry?.Abbreviation, step1.selectedState?.Abbreviation)' -->
                                <!-- <app-country-select name="worker_scountry"
                                    [(ngModel)]="step1.selectedCountry"
                                    [preselectedItemId]="step1.selectedCountry?step1.selectedCountry.ID:null" 
                                    [alltext]="'Please Select'" [showAll]="true" [labeltext]="'Country of Citizenship'" (ngModelChange)='getCountryRegionCode(step1.selectedCountry?.Abbreviation, step1.selectedState?.Abbreviation)'>
                                    <mat-icon class="ng-scope md-iwgNavbar-theme material-icons"
                                        matToolTip="Select the country in which the work will be performed."
                                        matTooltipPosition="'top'">
                                        help
                                    </mat-icon>
                        </app-country-select>
                    <mat-icon class="ng-scope md-iwgNavbar-theme material-icons"
                                        matToolTip="Select the country in which the work will be performed."
                                        matTooltipPosition="above">
                                        help
                                    </mat-icon> -->
                                <app-country-select class="icon-size" name="selectedCountry" [(ngModel)]="step1.selectedCountry" [alltext]="'Please Select'"
                                                    [helptext]="'Please select the country of citizenship for the worker.'"
                                                    [idOnly]="false"
                                                    [preselectedItemId]="step1.selectedCountry?step1.selectedCountry.ID:null"
                                                    (countryChange)="getCountryRegionCode($event.Abbreviation, step1.selectedState?.Abbreviation)"
                                                    [labeltext]="'Country'" [isRequired]="true" [required]="true">
                                </app-country-select>
                                <div class="md-input-container statewidth">
                                    <app-state-select name="stepFstate" *ngIf="showRegions && step1.selectedCountry?.HasRegions == true"
                                        [(ngModel)]="step1.selectedState"
                                        [preselected-item-id]="step1.selectedState?step1.selectedState.ID:-1"
                                        [countryId]="step1.selectedCountry?step1.selectedCountry.ID:null"
                                        [isDisabled]="false" [alltext]="'All'" [labeltext]="Region"
                                        [isRequired]="true" 
                                        (stateChange)="getCountryRegionCode(step1.selectedCountry, $event,true)">
                                        <mat-icon class="ng-scope md-iwgNavbar-theme material-icons"
                                            matToolTip="Select the region or state in which the work will be performed."
                                            matTooltipPosition="above">
                                            help
                                        </mat-icon>
                                    </app-state-select>
                                </div>
                                <div class="md-input-container" *ngIf="step1.service_type_id == 1">
                                    <mat-form-field class="mat-form-withtooltip">
                                        <mat-label>City</mat-label>
                                        <input matInput name="city" [(ngModel)]="step1.city" #Ccity="ngModel"
                                            name="city" maxlength="200">
                                            <mat-error *ngIf="!Ccity.valid && Ccity.touched">Required</mat-error>
                                    </mat-form-field>
                                    <mat-icon
                                        matTooltip="Provide the name of the city in which the work will be performed."
                                        matTooltipPosition="above" class="ng-scope md-iwgNavbar-theme material-icons">
                                        help</mat-icon>
                                   
                                </div>
                            </form>
                        </mat-tab>
                        <mat-tab label="Step 2">
                            <h3>Basic Information</h3>
                            <form name="quoteStep2" #quoteStep2="ngForm">
                                <div class="md-input-container">
                                    <mat-form-field class="mat-form-withtooltip">
                                        <mat-label>Number of Workers</mat-label>
                                        <input matInput [(ngModel)]="step2.number_of_workers" name="number_of_workers" #nWorker="ngModel"
                                            type="number" min="1" required>
                                            <mat-error *ngIf="!nWorker.valid && nWorker.touched">Required</mat-error>
                                    </mat-form-field>
                                    <mat-icon matTooltip="How many workers are expected to provide services?"
                                        matTooltipPosition="above" class="ng-scope md-iwgNavbar-theme material-icons">
                                        help</mat-icon>
                                </div>
                                <div class="md-input-container" *ngIf="step1.service_type_id == 1" fxLayout="row"
                                    fxLayoutAlign="start">
                                    <div class="matradiobtn" fxLayout="column" fxLayoutAlign="start start">
                                        
                                        <mat-label>Business Entity in Country *</mat-label>
                                        <mat-radio-group [(ngModel)]="step2.is_entity_in_country" class="d-block"
                                            #is_entity_in_country="ngModel" name="is_entity_in_country"
                                             required>
                                            <mat-radio-button [value]="true">Yes</mat-radio-button>
                                            <mat-radio-button [value]="false">No</mat-radio-button>
                                        </mat-radio-group>
                                       
                                        <input type="text" [(ngModel)]="step2.is_entity_in_country"
                                            style="display: none;" name="is_entity_in_country" required>
                                    </div>
                                    <div fxFlexAlign="baseline">
                                        <mat-icon style="margin-top: 16px;"
                                            matTooltip="Has your company established a business entity in this country? This may impact pricing and services."
                                            matTooltipPosition="above"
                                            class="ng-scope md-iwgNavbar-theme material-icons">help</mat-icon>
                                    </div>
                                </div>
                                <div class="md-input-container" *ngIf="step1.service_type_id == 1" fxLayout="row"
                                    fxLayoutAlign="start">
                                    <div class="matradiobtn" fxLayout="column" fxLayoutAlign="start start">
                                        <mat-label>Worker Residence *</mat-label>
                                        <mat-radio-group [(ngModel)]="step2.is_expat" class="d-block"
                                            #is_expat="ngModel" name="is_expat" aria-label="Select an option" required>
                                            <mat-radio-button [value]="false">Local</mat-radio-button>
                                            <mat-radio-button [value]="true">Expatriate</mat-radio-button>
                                        </mat-radio-group>
                                        <input type="text" [(ngModel)]="step2.is_expat" style="display: none;"
                                            name="is_expat" required>
                                    </div>
                                    <div fxFlexAlign="baseline">
                                        <mat-icon style="margin-top: 16px;"
                                            matTooltip="If the worker is a citizen of the country in which services will be provided, select 'Local.' If not, select 'Expatriate.'"
                                            matTooltipPosition="above"
                                            class="ng-scope md-iwgNavbar-theme material-icons">
                                            help</mat-icon>
                                    </div>
                                </div>
                                <div class="md-input-container" >
                                <app-country-select name="expat_nationality"   
                                *ngIf="step1.service_type_id == 1 && step2.is_expat==true"                                
                                    [(ngModel)]="step2.expat_nationality" [idOnly]="false"
                                    [preselectedItemId]="step2.expat_nationality?step2.expat_nationality.ID:null"
                                    [alltext]="'Please Select'" [showAll]="true" [labeltext]="'Country of Citizenship'"
                                    [isRequired]="true" [helptext]="'Please select the country of citizenship for the worker.'">                                    
                                </app-country-select>                               
                                </div>
                                <div class="md-input-container" *ngIf="step1.service_type_id == 1 && step2.is_expat == true" fxLayout="row"
                                    fxLayoutAlign="start">
                                    <div class="matradiobtn" fxLayout="column" fxLayoutAlign="start start">
                                        <mat-label>Visa / Work Permit Required *</mat-label>
                                        <mat-radio-group [(ngModel)]="step2.is_expat_visa_required" class="d-block"
                                            #is_expat_visa_required="ngModel" name="is_expat_visa_required"
                                            aria-label="Select an option">
                                            <mat-radio-button [value]="true">Yes</mat-radio-button>
                                            <mat-radio-button [value]="false">No</mat-radio-button>
                                        </mat-radio-group>
                                        <input type="text" [(ngModel)]="step2.is_expat_visa_required"
                                            style="display: none;" name="is_expat_visa_required" required>
                                    </div>

                                    <div fxFlexAlign="baseline">
                                        <mat-icon style="margin-top: 16px;"
                                            matTooltip="Does the worker need a visa?"
                                            matTooltipPosition="above"
                                            class="ng-scope md-iwgNavbar-theme material-icons">
                                            help</mat-icon>
                                    </div>
                                </div>
                                <div class="md-input-container" *ngIf="step1.service_type_id == 1 && step2.is_expat == true" fxLayout="row"
                                    fxLayoutAlign="start">
                                    <div class="matradiobtn" fxLayout="column" fxLayoutAlign="start start">
                                        <mat-label>Worker is in Country *</mat-label>
                                        <mat-radio-group [(ngModel)]="step2.is_worker_in_country" class="d-block"
                                            #is_worker_in_country="ngModel" name="is_worker_in_country"
                                            aria-label="Select an option">
                                            <mat-radio-button [value]="true">Yes</mat-radio-button>
                                            <mat-radio-button [value]="false">No</mat-radio-button>
                                        </mat-radio-group>
                                        <input type="text" [(ngModel)]="step2.is_worker_in_country"
                                            style="display: none;" name="is_worker_in_country" required>
                                    </div>
                                    <div fxFlexAlign="baseline">
                                        <mat-icon matTooltip="Is the worker in country now?" matTooltipPosition="above"
                                            class="ng-scope md-iwgNavbar-theme material-icons" style="margin-top: 16px;">help</mat-icon>
                                    </div>
                                </div>
                            </form>
                        </mat-tab>
                        <mat-tab label="Step 3">
                            <h3>Nature of Work</h3>
                            <form name="quoteStep3" #quoteStep3="ngForm">
                                <div class="md-input-container">
                                    <mat-form-field class="mat-form-withtooltip">
                                        <mat-label>Job Title</mat-label>
                                        <input matInput name="job_title" [(ngModel)]="step3.job_title"
                                            #Cjob_title="ngModel" maxlength="200" required>
                                            <mat-error *ngIf="!Cjob_title.valid && Cjob_title.touched">Required</mat-error>
                                    </mat-form-field>
                                   
                                     <mat-icon
                                        matTooltip="Please provide a job title that reflects the specific duties. Examples: Sales for Paris, Lead Software Enginner, Admin to CEO, etc."
                                        matTooltipPosition="above" class="ng-scope md-iwgNavbar-theme material-icons">
                                        help</mat-icon>
                                   </div>
                                <div class="md-input-container" *ngIf="step1.service_type_id == 1" fxLayout="row"
                                    fxLayoutAlign="start">
                                    <div class="matradiobtn" fxLayout="column" fxLayoutAlign="start start">
                                        <mat-label>Travel Required *</mat-label>
                                        <mat-radio-group [(ngModel)]="step3.is_travel_required" class="d-block"
                                            #is_travel_required="ngModel" name="is_travel_required"
                                            aria-label="Select an option">
                                            <mat-radio-button [value]="true">Yes</mat-radio-button>
                                            <mat-radio-button [value]="false">No</mat-radio-button>
                                        </mat-radio-group>
                                        <input type="text" [(ngModel)]="step3.is_travel_required" style="display: none;"
                                            name="is_travel_required" required>
                                    </div>
                                    <div fxFlexAlign="baseline">
                                        <mat-icon style="margin-top: 16px;"
                                            matTooltip="Please designate if the engagement requires travel, whether that be in country or abroad."
                                            matTooltipPosition="above"
                                            class="ng-scope md-iwgNavbar-theme material-icons">
                                            help</mat-icon>
                                    </div>
                                </div>
                                <div class="md-input-container">
                                    <mat-form-field class="mat-form-withtooltip">
                                        <mat-label>Job Description (Enter Text or Upload File)</mat-label>
                                        <textarea matInput [(ngModel)]="step3.job_description" name="job_description"
                                            rows="5" class="mat-textareafield"></textarea>
                                    </mat-form-field>
                                    <mat-icon style="position: absolute;margin-top: 15px;"
                                        matTooltip="A complete job description is necessary to engage the worker. If you have a job description as a document, please upload it, below. We support job description documents of the following format: doc, docx, pdf, txt, and rtf."
                                        matTooltipPosition="above" class="ng-scope md-iwgNavbar-theme material-icons">
                                        help
                                    </mat-icon>
                                </div>
                                <app-file-upload [upload-url]="'/Api/Quotes/'+existingQuoteId"
                                    *ngIf="step1.service_type_id == 1" [file-property]="'job_description_file'" [isEvent]="true"
                                    [uploaded-file-name]="step3.job_description_file" (uploadedfilename)='uploadedfile($event)'></app-file-upload>
                            </form>
                        </mat-tab>
                        <mat-tab label="Step 4">
                            <h3>Time and Compensation</h3>
                            <form name="quoteStep4" #quoteStep4="ngForm">
                                <div class="md-input-container">
                                    <mat-datepicker-toggle fxLayout="row" fxFlex="20" fxLayoutAlign="space-between center"
                                        matSuffix [for]="picker">
                                    </mat-datepicker-toggle>
                                    <mat-form-field color="accent" fxLayout="row" fxFlex="50"
                                        class="mat-form-withtooltip" floatLabel="always">
                                        <mat-label>Start Date</mat-label>
                                        <input matInput [matDatepicker]="picker" name="start_date" #start_date="ngModel"
                                            placeholder="Select" [(ngModel)]="step4.start_date" required>
                                        <mat-datepicker-toggle matSuffix [for]="picker">
                                            <mat-icon matDatepickerToggleIcon>arrow_drop_down</mat-icon>
                                        </mat-datepicker-toggle>
                                        <mat-datepicker #picker></mat-datepicker>
                                        <mat-error *ngIf="!start_date.valid && start_date.touched">Required</mat-error>
                                    </mat-form-field>
                                   <div fxLayout="row" fxFlex="30" fxLayoutAlign="end center"> 
                                        <mat-icon [ngStyle.gt-sm]="{'margin-right': '2px'}" matTooltip="Please specify the date on which the engagement will start."
                                            matTooltipPosition="above" class="ng-scope md-iwgNavbar-theme material-icons">
                                            help
                                        </mat-icon>
                                    </div>                               
                                </div>
                                <div class="md-input-container weekly-hour-input">
                                    <mat-form-field class="mat-form-withtooltip" fxLayout="row" fxFlex="90">
                                        <mat-label>Typical Weekly Hours</mat-label>
                                        <input matInput [(ngModel)]="step4.weekly_hours" name="weekly_hours"
                                            type="number" min="0.01" required>
                                    </mat-form-field>
                                    <div fxLayout="row" fxFlex="10" fxLayoutAlign="end center">
                                        <mat-icon  [ngStyle.gt-sm]="{'margin-right': '2px'}"
                                            matTooltip="Please specify the average number of hours each week the worker will provide services to your company."
                                            matTooltipPosition="above" class="ng-scope md-iwgNavbar-theme material-icons">
                                            help
                                        </mat-icon>
                                    </div>
                                </div>

                                <div fxLayout="row" fxFlex="100" class="iwg-form-label iwg-help-box mm--top-10">
                                    <span fxLayoutAlign="start center">Length of Project</span>
                                    <div class="ml-auto">
                                        <mat-icon
                                        matTooltip="How long do you expect the worker(s) to provide services to your company? If you are unsure or there is no specified end date, please select Project Length Indefinite."
                                        matTooltipPosition="above" class="ng-scope md-iwgNavbar-theme material-icons float-r">
                                        help
                                    </mat-icon>
                                    </div>
                                </div>
                                <div class="wrapFlexResp">
                                    <div class="md-input-container" fxFlex="25">
                                        <mat-form-field class="mat-form-withtooltip">
                                            <mat-label>Years</mat-label>
                                            <input matInput [(ngModel)]="step4.project_length_years"
                                                name="project_length_years" type="number" required
                                                [disabled]="step4.is_project_length_indefinite" min="0" (change)="OnChangeDuration('years')">
                                        </mat-form-field>
                                    </div>
                                    <div class="md-input-container" fxFlex="25">
                                        <mat-form-field class="mat-form-withtooltip">
                                            <mat-label>Months</mat-label>
                                            <input matInput [(ngModel)]="step4.project_length_months"
                                                name="project_length_months" type="number" required
                                                [disabled]="step4.is_project_length_indefinite" min="0" (change)="OnChangeDuration('months')">
                                        </mat-form-field>
                                    </div>
                                    <div class="md-input-container" fxFlex="25">
                                        <mat-form-field class="mat-form-withtooltip">
                                            <mat-label>Weeks</mat-label>
                                            <input matInput [(ngModel)]="step4.project_length_weeks"
                                                name="project_length_week" type="number" required
                                                [disabled]="step4.is_project_length_indefinite" min="0" (change)="OnChangeDuration('weeks')">
                                        </mat-form-field>
                                    </div>

                                    <div class="md-input-container chkLabel" style="margin-top: 12px;">
                                        <mat-checkbox class="example-margin" name="is_project_length_indefinite"
                                            [(ngModel)]="step4.is_project_length_indefinite"
                                            (change)="OnChangeDuration('indefinite')">Indefinite</mat-checkbox>
                                    </div>

                                </div>

                                <div fxLayout="row" fxFlex="100" class="iwg-form-label iwg-help-box mm--top-10">
                                    <span fxLayoutAlign="start center">Pay</span>
                                    <div class="ml-auto">
                                        <mat-icon style="float: right;" matTooltip="How much do you expect to pay the worker(s)?"
                                        matTooltipPosition="above" class="ng-scope md-iwgNavbar-theme material-icons float-r">
                                        help
                                        </mat-icon>
                                    </div>
                                </div>
                                <div>

                                    <div class="md-input-container" fxFlex="30">
                                        <mat-form-field class="mat-form-withtooltip">
                                            <mat-label>Amount</mat-label>
                                            <input matInput [(ngModel)]="step4.pay_rate" min="0.01" name="pay_rate"
                                                type="number" required>
                                        </mat-form-field>
                                    </div>
                                    <div fxFlex="30">
                                        <app-currency-select [(ngModel)]="step4.selectedCurrency" name="currencys"
                                            [helptext]="" [required] = "true"
                                            [preselected-item-id]="step4.selectedCurrency?step4.selectedCurrency.ID:null">
                                        </app-currency-select>
                                    </div>
                                    <div fxFlex="30">
                                        <app-pay-rate-select [(ngModel)]="step4.selectedPayRateType" name="payrateSel" [showHelpText] = "false"
                                        [preselected-item-id]="step4.selectedPayRateType?.ID" [required] = "true" style="width: 100%;"
                                        [helptext]="''"></app-pay-rate-select>
                                    </div>
                                </div>


                                <div class="md-input-container" fxLayout="row" fxLayoutAlign="start">

                                    <div class="matradiobtn" fxLayout="column" fxLayoutAlign="start start">
                                        <mat-label>Commissions Authorized*</mat-label>
                                        <mat-radio-group required #is_commission_authorized="ngModel"
                                            [(ngModel)]="step4.is_commission_authorized" class="d-block"
                                            name="is_commission_authorized" aria-label="Select an option" required>
                                            <mat-radio-button [value]="true">Yes</mat-radio-button>
                                            <mat-radio-button [value]="false">No</mat-radio-button>
                                        </mat-radio-group>

                                    </div>
                                    <div fxFlexAlign="baseline">
                                        <mat-icon style="margin-top: 16px;"
                                            matTooltip="Will the worker have the opportunity to earn bonuses as part of this engagement?"
                                            matTooltipPosition="above"
                                            class="ng-scope md-iwgNavbar-theme material-icons">
                                            help</mat-icon>
                                    </div>
                                    <mat-error
                                        *ngIf="!is_commission_authorized.valid && is_commission_authorized.touched">
                                        Required</mat-error>
                                </div>




                                <div class="md-input-container" fxLayout="row" fxLayoutAlign="start">

                                    <div class="matradiobtn" fxLayout="column" fxLayoutAlign="start start">
                                        <mat-label>Bonuses Authorized*</mat-label>
                                        <mat-radio-group required #is_bonus_authorized="ngModel"
                                            [(ngModel)]="step4.is_bonus_authorized" class="d-block"
                                            name="is_bonus_authorized" aria-label="Select an option" required>
                                            <mat-radio-button [value]="true">Yes</mat-radio-button>
                                            <mat-radio-button [value]="false">No</mat-radio-button>
                                        </mat-radio-group>
                                        
                                        <mat-error *ngIf="!is_bonus_authorized.valid && is_bonus_authorized.touched">
                                            Required</mat-error>

                                    </div>
                                    <div fxFlexAlign="baseline">
                                        <mat-icon style="margin-top: 16px;"
                                            matTooltip="Has your company established a business entity in this country? This may impact pricing and services."
                                            matTooltipPosition="above"
                                            class="ng-scope md-iwgNavbar-theme material-icons">
                                            help</mat-icon>
                                    </div>
                                </div>


                                <div class="md-input-container">
                                    <mat-form-field class="mat-form-withtooltip">
                                        <mat-label> Compensation Details — Bonuses, Commissions, Etc.</mat-label>
                                        <textarea matInput cdkTextareaAutosize [(ngModel)]="step4.other_compensation"
                                            rows="5" name="other_compensation" class="mat-textareafield"></textarea>
                                    </mat-form-field>
                                    <mat-icon style="position:absolute;margin-top: 17px;"
                                        matTooltip="Please provide details regarding commissiones, bonuses, and other forms of compensation for this engagement. Please include financial amounts, conditions, and timing."
                                        matTooltipPosition="above" class="ng-scope md-iwgNavbar-theme material-icons">
                                        help
                                    </mat-icon>
                                </div>



                                <div class="md-input-container">
                                    <mat-form-field class="mat-form-withtooltip">
                                        <mat-label>Additional Notes</mat-label>
                                        <textarea matInput cdkTextareaAutosize [(ngModel)]="step4.client_notes"
                                            name="client_notes" rows="5" class="mat-textareafield"></textarea>
                                    </mat-form-field>
                                </div>

                            </form>
                        </mat-tab>
                        <mat-tab label="review">
                            
                        <div class="reviewQuoteDiv">                            
                            <h3 class="h3-font-bold">Review Quote Details</h3>
                            <div>
                                <div class="iwg-review-bar" layout="row" layout-align="start center">
                                    <span class="iwg-review-bar-title">Step 1: Service and Location</span><span
                                        flex></span><a (click)="selectedStepIndex = 0"
                                        class="iwg-review-bar-edit">Edit</a>
                                </div>
                                <div class="iwg-widget-box-card">
                                    <label class="iwg-regular-label">Service</label>
                                    <p class="iwg-regular-value">{{step1.selectedServiceName}}</p>
                                </div>
                                <div class="iwg-widget-box-card">
                                    <label class="iwg-regular-label">Quote Title</label>
                                    <p class="iwg-regular-value">{{step1.title}}</p>
                                </div>
                                <div class="iwg-widget-box-card" *ngIf="allowEndClients">
                                    <label class="iwg-regular-label">End Client</label>
                                    <p class="iwg-regular-value" *ngIf="step1.selectedEndClient">
                                        {{step1.selectedEndClient.Name}}</p>
                                </div>
                                <div class="iwg-widget-box-card" *ngIf="allowTeams">
                                    <label class="iwg-regular-label">Team</label>
                                    <p class="iwg-regular-value" *ngIf="step1.selectedTeam">{{step1.selectedTeam.Name}}
                                    </p>
                                </div>
                                <div class="iwg-widget-box-card">
                                    <label class="iwg-regular-label">Country</label>
                                    <p class="iwg-regular-value" *ngIf="step1.selectedCountry">
                                        {{step1.selectedCountry.Name}}</p>
                                </div>
                                <div class="iwg-widget-box-card"
                                    *ngIf="step1.selectedState && step1.service_type_id != 2">
                                    <label class="iwg-regular-label">Region</label>
                                    <p class="iwg-regular-value" *ngIf="step1.selectedState">
                                        {{step1.selectedState.Name}}</p>
                                </div>
                                <div class="iwg-widget-box-card" *ngIf="step1.service_type_id == 1">
                                    <label class="iwg-regular-label">City</label>
                                    <p class="iwg-regular-value">{{step1.city}}</p>
                                </div>
                            </div>
                            <div *ngIf="step1.service_type_id == 1">
                                <div class="iwg-review-bar" layout="row" layout-align="start center">
                                    <span class="iwg-review-bar-title">Step 2: Basic Information</span><span
                                        flex></span><a (click)="goNext(1)"
                                        class="iwg-review-bar-edit">Edit</a>
                                </div>
                                <div class="iwg-widget-box-card" *ngIf="step1.service_type_id == 1">
                                    <label class="iwg-regular-label">Business Entity in Country</label>
                                    <p class="iwg-regular-value">{{step2.is_entity_in_country | yesNo}}</p>
                                </div>
                                <div class="iwg-widget-box-card">
                                    <label class="iwg-regular-label">Number of Workers</label>
                                    <p class="iwg-regular-value">{{step2.number_of_workers}}</p>
                                </div>
                                <div class="iwg-widget-box-card" *ngIf="step1.service_type_id == 1">
                                    <label class="iwg-regular-label">Residence</label>
                                    <p class="iwg-regular-value">{{step2.is_expat ? 'Expat' : 'Local'}}</p>
                                </div>
                                <div class="iwg-widget-box-card"
                                    *ngIf="step1.service_type_id == 1 && step2.is_expat == true">
                                    <label class="iwg-regular-label">Country of Citizenship</label>
                                    <p class="iwg-regular-value" *ngIf="step2.expat_nationality">
                                        {{step2.expat_nationality.Name}}</p>
                                </div>
                                <div class="iwg-widget-box-card"
                                    *ngIf="step1.service_type_id == 1 && step2.is_expat == true">
                                    <label class="iwg-regular-label">Visa / Work Permit Required</label>
                                    <p class="iwg-regular-value">{{step2.is_expat_visa_required ? 'Yes' : 'No'}}</p>
                                </div>
                                <div class="iwg-widget-box-card"
                                    *ngIf="step1.service_type_id == 1 && step2.is_expat == true">
                                    <label class="iwg-regular-label">Worker is in Country</label>
                                    <p class="iwg-regular-value">{{step2.is_worker_in_country ? 'Yes' : 'No'}}</p>
                                </div>
                            </div>
                            <div *ngIf="step1.service_type_id == 1">
                                <div class="iwg-review-bar" layout="row" layout-align="start center">
                                    <span class="iwg-review-bar-title">Step 3: Nature of Work</span><span flex></span><a
                                        (click)="goNext(2)" class="iwg-review-bar-edit">Edit</a>
                                </div>
                                
                                <div class="iwg-widget-box-card">
                                    <label class="iwg-regular-label">Job Title</label>
                                    <p class="iwg-regular-value">{{step3.job_title}}</p>
                                </div>
                                <div class="iwg-widget-box-card" *ngIf="step1.service_type_id == 1">
                                    <label class="iwg-regular-label">Travel Required</label>
                                    <p class="iwg-regular-value">{{step3.is_travel_required | yesNo}}</p>
                                </div>
                                <div class="iwg-widget-box-card" *ngIf="step1.service_type_id == 1">
                                    <label class="iwg-regular-label">Job Description</label>
                                    <pre
                                        style="font-size: 14px;color: #333;margin: 0;white-space: pre-line;font-family: Lato,Helvetica Neue,sans-serif;">{{step3.job_description}}</pre>
                                </div>
                                <div class="iwg-widget-box-card" *ngIf="step1.service_type_id == 1">
                                    <label class="iwg-regular-label">Job Description File</label>
                                    <p class="iwg-regular-value"
                                        style="width:250px; overflow-wrap: break-word;white-space: normal;">
                                        {{step3.job_description_file | blank}}
                                        <button class="mat-icon-button" [disabled]="isLoading"
                                            *ngIf="step3.job_description_file" (click)="downloadJobDescriptionFile()" style="color: rgba(0,0,0,0.54);">
                                            <mat-icon style="vertical-align: middle;">
                                                file_download
                                            </mat-icon>
                                        </button>
                                    </p>
                                </div>
                            </div>
                            <div *ngIf="step1.service_type_id == 1">
                                <div class="iwg-review-bar" layout="row" layout-align="start center">
                                    <span class="iwg-review-bar-title">Step 4: Time and Compensation</span><span
                                        flex></span><a (click)="goNext(3)"
                                        class="iwg-review-bar-edit">Edit</a>
                                </div>
                                <div class="iwg-widget-box-card">
                                    <label class="iwg-regular-label">Start Date</label>
                                    <p class="iwg-regular-value">{{step4.start_date | date}}</p>
                                </div>
                                <div class="iwg-widget-box-card">
                                    <label class="iwg-regular-label">Typical Weekly Hours</label>
                                    <p class="iwg-regular-value">{{step4.weekly_hours}}</p>
                                </div>
                                <div class="iwg-widget-box-card">
                                    <label class="iwg-regular-label">Length of Project</label>
                                    <p class="iwg-regular-value" *ngIf="step4.is_project_length_indefinite">
                                        Indefinite
                                    </p>
                                     <p class="iwg-regular-value" *ngIf="!step4.is_project_length_indefinite">
                                        <span [ngPlural]="step4.project_length_years" class="m-right10" *ngIf="step4.project_length_years!=null">
                                         <ng-template ngPluralCase="0"></ng-template>
                                         <ng-template ngPluralCase="one">1 year</ng-template>
                                         <ng-template ngPluralCase="other">{{step4.project_length_years}} years</ng-template>
                                        </span>
                                        <span [ngPlural]="step4.project_length_months" class="m-right10" *ngIf="step4.project_length_months!=null">
                                            <ng-template ngPluralCase="0"></ng-template>
                                            <ng-template ngPluralCase="one">1 month</ng-template>
                                            <ng-template ngPluralCase="other">{{step4.project_length_months}} months</ng-template>
                                        </span>
                                        <span [ngPlural]="step4.project_length_weeks" class="m-right10" *ngIf="step4.project_length_weeks!=null">
                                            <ng-template ngPluralCase="0"></ng-template>
                                            <ng-template ngPluralCase="one">1 week</ng-template>
                                            <ng-template ngPluralCase="other">{{step4.project_length_weeks}} weeks</ng-template>
                                        </span>
                                    </p> 
                                </div>
                                <div class="iwg-widget-box-card">
                                    <label class="iwg-regular-label">Pay Rate</label>
                                    <p class="iwg-regular-value"
                                        *ngIf="step4.selectedCurrency && step4.selectedPayRateType">
                                        {{step4?.pay_rate | number}} {{step4.selectedCurrency.Name}} /
                                        {{step4.selectedPayRateType.Name}}</p>
                                </div>
                                <div class="iwg-widget-box-card">
                                    <label class="iwg-regular-label">Commissions Authorized</label>
                                    <p class="iwg-regular-value">{{step4.is_commission_authorized| yesNo}}</p>
                                </div>
                                <div class="iwg-widget-box-card">
                                    <label class="iwg-regular-label">Bonuses Authorized</label>
                                    <p class="iwg-regular-value">{{step4.is_bonus_authorized| yesNo}}</p>
                                </div>
                                <div class="iwg-widget-box-card">
                                    <label class="iwg-regular-label">Additional Compensation</label>
                                    <p class="iwg-regular-value">{{step4.other_compensation }}</p>
                                </div>
                                <div class="iwg-widget-box-card">
                                    <label class="iwg-regular-label">Additional Notes</label>
                                    <p class="iwg-regular-value">{{step4.client_notes}}</p>
                                </div>
                            </div>
                        </div>
                           
                        </mat-tab>
                    </mat-tab-group>
                    </div>
                    <mat-dialog-actions align="end" class="justify-fend">

                        <div fxLayout="row" fxLayoutAlign="space-between center" style="overflow:auto;">
                            <div class="vista-action-btnback">
                                <button class="back-btn-vista" mat-button [disabled]="isFileUploadInProgress"
                                    *ngIf="selectedStepIndex != 0" (click)="prevStep()">« Back</button>
                            </div>
                
                            <div class="vista-action-btn">
                                <button mat-button mat-dialog-close [disabled]="isFileUploadInProgress" *ngIf="selectedStepIndex == 0"
                                    (click)="cancel()">Cancel</button>
                            </div>
                           
                            <div class="vista-action-btn">
                                <button mat-button [disabled]="isFileUploadInProgress" class="mobile-responsive"
                                    *ngIf="selectedStepIndex == 1 || selectedStepIndex == 2 || selectedStepIndex == 3 || selectedStepIndex == 4" (click)="saveAsDraft()"><span class="hidexs">Save As</span>&nbsp;<span>Draft</span></button>
                                
                            </div>
            
                            <div class="vista-action-btn">
                                <button mat-button class="vista-dialogbtn" *ngIf="selectedStepIndex != 4" (click)="nextStep()" [disabled]="pageLoaded && (!canProceed() || isFileUploadInProgress)"><span class="hidexs">Save &</span>&nbsp;<span>Continue</span></button>
                            </div>
                
                
                            <div class="vista-action-btn">
                                <button mat-button class="vista-dialogbtn" *ngIf="selectedStepIndex == 4"
                                    (click)="submit()">Submit</button>
                            </div>
                
                        </div>
                    </mat-dialog-actions>
                </div>
                <div fxFlex="50" class="d-flex layout-column flex md-padding w-100 mobilemaphide" *ngIf="selectedStepIndex < 4" style="overflow-x: auto;width:50px">
                  
                    <div>
                    <app-quote-dialog-map
                        [resetFormSubject]="resetFormSubject.asObservable()" [quoteMapCode]="quoteMapCode"></app-quote-dialog-map></div>

                </div>
            </div>
        </div>
        
    </mat-dialog-content>
   
</div>